<div class="modal-container">
  @if (isArchived) {
    <h1 i18n>Are you sure you want to unarchive this template?</h1>
    <h3 i18n>
      By unarchiving this template, you will be able to produce new content. Content produced before archiving will not be brought back.
    </h3>
  } @else {
    <h1 i18n>Are you sure you want to archive this template?</h1>
    <h3 i18n>By archiving this template, all existing content will be deleted and no new content will be produced.</h3>
  }
  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" (click)="archiveTemplate()" i18n>Confirm</button>
  </section>
</div>
